import { request } from '../platform/index'
import { getTraceId } from '../utils/index'

// 接口文档地址：https://easydoc.net/s/77671813/emcAIGtM/zoP6Xm3J
export const uploadMonitor = function (params, options, success, error) {
  const logUrl = options && options.logUrl ? options.logUrl : 'https://apibene.youhaoji.cn/app/tracking_ntrenventtrackingrecord/v1.0.0/add'

  request.post(logUrl, {
    traceId: getTraceId(),
    ...params
  }).then(response => {
    typeof success === 'function' && success(response) // 成功和错误都抛出去
  }).catch(error => {
    typeof error === 'function' && error(error)
  })
}



// WEBPACK FOOTER //
// ./src/npm/monitor/api/upload.js